var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _c("div", [
        _c(
          "ul",
          { staticClass: "breadcrumb d-block px-3 py-0" },
          [
            _c("li", {
              staticClass: "btn-close",
              on: {
                click: function ($event) {
                  return _vm.closeNavigation()
                },
              },
            }),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "breadcrumb-item",
                on: {
                  click: function ($event) {
                    return _vm.slideTo(null, true)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-home",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.breadcrumbs, function (breadcrumb) {
              return _c(
                "li",
                {
                  staticClass: "breadcrumb-item",
                  on: {
                    click: function ($event) {
                      return _vm.slideTo(breadcrumb.parent, true)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(breadcrumb.name) + "\n      ")]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            directives: [{ name: "menu", rawName: "v-menu" }],
            staticClass: "mainmenu w-100 p-0 m-0 menu-active",
            attrs: { id: "menu-1" },
          },
          _vm._l(_vm.categories, function (category) {
            return _c("li", { staticClass: "ddown" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.isFrench ? category.urlFrench : category.url,
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.isFrench
                          ? category.categoryNameFrench
                          : category.categoryNameGerman
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }